export class Global {
    static isIndexedDbSupported = true;
}